import { render, staticRenderFns } from "./EntradaCaixa.vue?vue&type=template&id=fbaa4434"
import script from "./EntradaCaixa.vue?vue&type=script&lang=js"
export * from "./EntradaCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports